import { message } from 'antd';

import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { updateStudyAPI } from '../../services/group-admin-service';

import { assignVisitRadiologistAPI, fetchMipRadiologistUsersAPI, fetchWorklistVisitsAPI, updateWorklistVisitRadiologistAPI } from '../../services/visits-report-service';
import { FETCH_MIP_RADIOLOGIST_USERS, FETCH_MIP_RADIOLOGIST_USERS_ERROR, FETCH_MIP_RADIOLOGIST_USERS_SUCCESS, FETCH_WORKLIST_VISITS, FETCH_WORKLIST_VISITS_ERROR, FETCH_WORKLIST_VISITS_START, FETCH_WORKLIST_VISITS_SUCCESS, SET_WORKLIST_FILTER, SET_WORKLIST_PAGINATION, UPDATE_WORKLIST_VISIT_RADIOLOGIST, UPDATE_WORKLIST_VISIT_RADIOLOGIST_ERROR, UPDATE_WORKLIST_VISIT_RADIOLOGIST_START, UPDATE_WORKLIST_VISIT_RADIOLOGIST_SUCCESS, UPDATE_WORKLIST_VISIT_STUDY, UPDATE_WORKLIST_VISIT_STUDY_ERROR, UPDATE_WORKLIST_VISIT_STUDY_START, UPDATE_WORKLIST_VISIT_STUDY_SUCCESS } from '../actions/worklistVisitsActions';

function* fetchWorklistVisits({ payload }) {
    try {
        yield put({ type: FETCH_WORKLIST_VISITS_START })
        const response = yield call(fetchWorklistVisitsAPI, payload);

        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            const worklist = Array.isArray(response.data)
                ? response.data
                : response.data.worklistVisits || response.data.worklist || response.data.visits || response.data.content || [];
            yield put({ type: FETCH_WORKLIST_VISITS_SUCCESS, worklist });
            yield put({ type: SET_WORKLIST_PAGINATION, pagination });
            yield put({ type: SET_WORKLIST_FILTER, payload: { ...payload } });
        } else {
            yield put({ type: FETCH_WORKLIST_VISITS_ERROR, error: response.error })
            message.error('Failed to fetch worklist visits!');
        }
    } catch (error) {
        yield put({ type: FETCH_WORKLIST_VISITS_ERROR, error: error })
        message.error('Failed to fetch worklist visits!');
    }
}

function* fetchMipRadiologyUsers({ payload }) {
    try {

        const response = yield call(fetchMipRadiologistUsersAPI, payload);

        if (response.success) {
            yield put({ type: FETCH_MIP_RADIOLOGIST_USERS_SUCCESS, mipRadiologistUsers: response.data });
        } else {
            yield put({ type: FETCH_MIP_RADIOLOGIST_USERS_ERROR, error: response.error })
            message.error('Failed to fetch radiologists!');
        }
    } catch (error) {
        yield put({ type: FETCH_MIP_RADIOLOGIST_USERS_ERROR, error: error })
        message.error('Failed to fetch radiologists!');
    }
}


function* updateWorklistVisitRadiologist({ payload, clearSelectedRow }) {
    try {
        yield put({ type: UPDATE_WORKLIST_VISIT_RADIOLOGIST_START })
        // const response = yield call(updateWorklistVisitRadiologistAPI, payload);
        const response = yield call(assignVisitRadiologistAPI, payload);
        console.log('response', response);

        if (response.success) {
            message.success('Your assignment will reflect in 5 minutes.')
            clearSelectedRow();
            yield put({ type: UPDATE_WORKLIST_VISIT_RADIOLOGIST_SUCCESS, summary: response.data });
        } else {
            if (response.error) {
                message.error(response.error);
            } else {
                message.error('Failed to assign radiologists.')
            }
            yield put({ type: UPDATE_WORKLIST_VISIT_RADIOLOGIST_ERROR, error: response.error })
        }
    } catch (error) {
        yield put({ type: UPDATE_WORKLIST_VISIT_RADIOLOGIST_ERROR, error: error })
        message.error('Failed to update visit radiologist!',);
    }
}


function* updateWorklistVisitStudy({ payload }) {
    try {
        yield put({ type: UPDATE_WORKLIST_VISIT_STUDY_START })
        let response = yield call(updateStudyAPI, payload);
        if (response.data) {
            message.success('Updated visit successfully');
            yield put({ type: UPDATE_WORKLIST_VISIT_STUDY_SUCCESS, visit: payload })
        } else {
            yield put({ type: UPDATE_WORKLIST_VISIT_STUDY_ERROR });
            message.error('Failed to update visit!');
        }
    } catch (error) {
        message.error('Failed to update visit!');
        yield put({ type: UPDATE_WORKLIST_VISIT_STUDY_ERROR, error })
    }
}

function* worklistVistsWatcher() {
    yield takeEvery(FETCH_WORKLIST_VISITS, fetchWorklistVisits)
    yield takeEvery(FETCH_MIP_RADIOLOGIST_USERS, fetchMipRadiologyUsers)
    yield takeEvery(UPDATE_WORKLIST_VISIT_RADIOLOGIST, updateWorklistVisitRadiologist)
    yield takeLatest(UPDATE_WORKLIST_VISIT_STUDY, updateWorklistVisitStudy)
}

export default function* rootSaga() {
    yield all([
        worklistVistsWatcher(),
    ]);
}
